var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "job-application-accordion card" },
    [
      _c("div", { staticClass: "p-4" }, [
        _c(
          "div",
          { staticClass: "grid-x grid-padding-x grid-padding-y border-b" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "cell auto" }, [
              _c("span", { staticClass: "text-site-gray f-15 bold" }, [
                _vm._v("Job Applications "),
                _c("small", { staticClass: "minutes" }, [
                  _vm._v("(" + _vm._s(_vm.jobApplications.length) + ")")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cell shrink" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.open = !_vm.open
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "fa",
                    class: _vm.open ? "fa-chevron-up" : "fa-chevron-down"
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.open,
                    expression: "open"
                  }
                ],
                staticClass: "cell small-12"
              },
              [
                _vm._l(_vm.jobApplications, function(jobApplication) {
                  return _c(
                    "div",
                    {
                      key: jobApplication.id,
                      staticClass: "grid-x grid-padding-x job-application"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "cell auto job-app-title" },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(jobApplication.job.title) +
                              " (#" +
                              _vm._s(jobApplication.job.requisition_id) +
                              ")\n\n                            "
                          ),
                          jobApplication.status
                            ? [
                                _vm._v(
                                  "\n                                -\n                                "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "job-application-status ml-4",
                                    class: jobApplication.status
                                  },
                                  [
                                    jobApplication.status
                                      ? _c("strong", [
                                          _vm._v(
                                            "\n                                        Unsuccessful - \n                                    "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                jobApplication.fail_reason
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(jobApplication.fail_reason) +
                                          "\n                                "
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "cell shrink" }, [
                        !jobApplication.status
                          ? _c("span", [
                              _vm._v(
                                "\n                                Step - X\n                            "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !["failed", "recycled"].includes(jobApplication.status)
                          ? _c(
                              "a",
                              {
                                staticClass: "button small continue",
                                attrs: {
                                  href:
                                    "/candidate/job-applications/view/" +
                                    jobApplication.id
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Continue\n                            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !["failed", "recycled"].includes(jobApplication.status)
                          ? _c(
                              "a",
                              {
                                staticClass: "button small continue withdraw",
                                on: {
                                  click: function($event) {
                                    return _vm.withdrawApplication(
                                      jobApplication.id
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Cancel\n                            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        ["failed"].includes(jobApplication.status) &&
                        jobApplication.is_reappliable &&
                        _vm.isRequisitionActive(
                          jobApplication.job.requisition.closing_date
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "button small continue dark",
                                attrs: {
                                  href:
                                    "/candidate/job-applications/reapply/" +
                                    jobApplication.id
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Reapply\n                            "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                })
              ],
              2
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("confirm-withdraw-application-modal", {
        ref: "confirmWithdrawApplicationModal",
        attrs: {
          "job-application-id": _vm.currentJobApplicationId,
          "csrf-token": _vm.csrfToken
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell shrink" }, [
      _c("img", { attrs: { src: "/img/icons/id-card.svg", alt: "Icon" } })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-294bf0a8", { render: render, staticRenderFns: staticRenderFns })
  }
}